/*
Abstractions for API requests
For School Quality Snapshot
*/

import ApiBase from '@/api/base'
import { API_DATA_PATH } from '@/api/const'

const appDataPath = API_DATA_PATH + '/school/app/snapshot'

class SqsApiBase extends ApiBase {
  apiName = ''
  get apiBaseUrl () { return `${appDataPath}/${this.apiName}` }
}

export class SQSAllDataApi extends SqsApiBase {
  apiName = 'all'
  get url () {
    const {year, dbn, reportType} = this.params
    return `${this.apiBaseUrl}/${year}/${dbn}/${reportType}`
  }
}
export class SQSAllDataPreviewApi extends SQSAllDataApi {
  apiName = 'all/preview'
}

export class FrameworkScoresApi extends SqsApiBase {
  apiName = 'framework-scores'
  get url () {
    const {year, dbn, reportType} = this.params
    return `${this.apiBaseUrl}/${year}/${dbn}/${reportType}`
  }
}



// WEBPACK FOOTER //
// ./src/api/data/sqs.js